import { useState } from "react";
import { faqItems } from "@/mocks/data";

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-950">
            常见问题
          </h2>
          <p className="mt-3 text-foreground-600 text-sm">
            关于成人影院的常见疑问，这里都有解答
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {faqItems.map((item, index) => (
            <div
              key={index}
              className="bg-background-50 border border-background-200/70 rounded-lg overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-100 transition-colors duration-200"
              >
                <span className="text-sm font-medium text-foreground-900 pr-4">
                  {item.question}
                </span>
                <i
                  className={`ri-${
                    openIndex === index ? "subtract" : "add"
                  }-line text-lg text-foreground-400 flex-shrink-0 w-5 h-5 flex items-center justify-center transition-transform duration-300`}
                ></i>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openIndex === index ? "max-h-96" : "max-h-0"
                }`}
              >
                <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                  {item.answer}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}